<oaibox-top-bar>
  <oaibox-keycloak-profile profile></oaibox-keycloak-profile>
</oaibox-top-bar>
<oaibox-unauthorized-page>
</oaibox-unauthorized-page>
